// extracted by mini-css-extract-plugin
export default {"container":"_2sMs_zaG8F7xC_fP_KcGHZ"};